import { NgModule } from "@angular/core";
import { SharedModule, addNavMenuSection } from "@vendure/admin-ui/core";

@NgModule({
  imports: [SharedModule],
  providers: [
    addNavMenuSection(
      {
        id: "subscriber-nav",
        label: "Newsletter",
        items: [
          {
            id: "newsletter-subscribers",
            label: "Subscribers",
            routerLink: ["/extensions/newsletter/subscribers"],
            // Icon can be any of https://clarity.design/icons
            icon: "folder-open",
          },
        ],
        requiresPermission: "SuperAdmin",
      },
      // Add this section before the "settings" section
      "settings"
    ),
  ],
})
export class NewsletterSharedModule {}
